import styles from '../index.less';
const BreadHead = ({ initData, pageId, title, secondInfo }: any) => {
  const onClickOpen = (url?: any) => {
    if (url) {
      window.open(url);
    } else {
      window.open(window.location.origin);
    }
  };
  const onClickhref = (url: any) => {
    window.location.href = url;
  };
  return (
    <div className={styles.bread}>
      {/* 当前位置： */}
      <div className={styles.describe}>
        <div>
          当前位置：
          {/* 当前位置： */}
          <i
            data-a-href="/"
            onClick={() => {
              onClickOpen();
            }}
          >
            京东健康
          </i>
          <span>{">"}</span>
          {initData?.hospitalName ? (
            <>
              <span data-tag-h1={Boolean(!title && !secondInfo) ? true : undefined} data-a-href={
                (title || secondInfo) && "/hospital/" + pageId
              }
              onClick={() => {
                (title || secondInfo) && onClickhref("/hospital/" + pageId);
              }}>{initData?.hospitalName}</span>
              {secondInfo?.departName && <span>{">"}</span>}
              {secondInfo?.departName &&
                <a data-tag-h1={Boolean(!title) ? true : undefined } data-a-href={
                  title && "/hospital/department/" + pageId + '-' + secondInfo?.id
                }
                onClick={() => {
                  title && onClickhref( "/hospital/department/" + pageId + '-' + secondInfo?.id);
                }}>{secondInfo?.departName}</a>
              }
              {title && <span>{">"}</span>}
              {title && <p data-tag-h1={Boolean(title) ? true : undefined}>{title}</p>}
            </>
          ) : null}
        </div>
      </div>
    </div>
    )
}
export default BreadHead;